export const FIELD_EVALUATION_REPORT_DIALOG_PREVIEW_NAMES = [
  'fieldEvaluationReportDialog/preview1',
  'fieldEvaluationReportDialog/preview2',
  'fieldEvaluationReportDialog/preview3',
]
